import { Theme, Typography } from '@mui/material'
import { CSSProperties, ReactNode } from 'react'
import { FieldPath, FieldValues, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { DEFAULT_MAX_RTT } from '../../constants'

type Props<Schema extends FieldValues> = {
  path: FieldPath<Schema>
}

export const MaxRttSoftValidator = <Schema extends FieldValues>({
  path,
}: Props<Schema>): ReactNode => {
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'defaults.prebid.connectionSpeed',
  })
  const value = useWatch<Schema>({ name: path })

  if (value === undefined || value >= DEFAULT_MAX_RTT) {
    return undefined
  }

  return (
    <Typography
      component='span'
      sx={(theme: Theme): CSSProperties => ({ color: theme.palette.warning.main })}
      variant='caption'
    >
      {t('maxRtt.recommendedMinimum')}
    </Typography>
  )
}
